import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import SubscribersManagement from './email/SubscribersManagement';
import TemplateManagement from './email/TemplateManagement';
import EmailLogs from './email/EmailLogs';
import EmailStats from './email/EmailStats';
import AdminSiteSettings from './email/SiteSettings';

export default function EmailManagementTab() {
  const [activeSubTab, setActiveSubTab] = useState<'subscribers' | 'templates' | 'logs' | 'stats' | 'settings'>('subscribers');

  const subTabs = [
    { id: 'subscribers' as const, label: 'Subscribers', icon: '👥' },
    { id: 'templates' as const, label: 'Email Templates', icon: '📝' },
    { id: 'logs' as const, label: 'Email Logs', icon: '📊' },
    { id: 'stats' as const, label: 'Statistics', icon: '📈' },
    { id: 'settings' as const, label: 'Settings', icon: '⚙️' },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Mail className="h-6 w-6 text-blue-600" />
        <h2 className="text-2xl font-bold">Email Management</h2>
      </div>

      {/* Statistics Overview */}
      <EmailStats />

      {/* Sub-tabs */}
      <div className="flex space-x-1 bg-gray-100 dark:bg-gray-800 p-1 rounded-lg">
        {subTabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveSubTab(tab.id)}
            className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
              activeSubTab === tab.id
                ? 'bg-white dark:bg-gray-700 text-blue-600 dark:text-blue-400 shadow-sm'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
            }`}
          >
            <span>{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6">
        {activeSubTab === 'subscribers' && <SubscribersManagement />}
        {activeSubTab === 'templates' && <TemplateManagement />}
        {activeSubTab === 'logs' && <EmailLogs />}
        {activeSubTab === 'stats' && (
          <div className="text-center py-8 text-gray-500 dark:text-gray-400">
            Detailed statistics view coming soon...
          </div>
        )}
        {activeSubTab === 'settings' && <AdminSiteSettings />}
      </div>
    </div>
  );
}
